// extracted by mini-css-extract-plugin
module.exports = {"text":"DriverBankAccountsDetails_text__yZ-yp","tooltip":"DriverBankAccountsDetails_tooltip__ffocP"};